module.exports = __webpack_public_path__ + "static/wallace-9c5e1bf239da09af7af80eb3dbac3444.png";